
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, ButtonBase, Typography, Tabs, Tab } from '@material-ui/core';
import AppUtils from '../../control/apputlis';
import DateUtils from '../../control/dateutils';
import TabIndicator from '../view/TabIndicator';

const ICON = require("../../images/icons/rili.png");

class MatchTitle extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: props.value,
        };
    }

    _handleChange(val) {
        this.setState({ value: val });
        this.props.onChange && this.props.onChange(val);
    }

    render() {
        const { classes } = this.props;
        const { value } = this.state;

        let timer = AppUtils.getStorageInt(AppUtils.MATCH_SELECT_TIMER);
        if (timer == 0) {
            timer = DateUtils.getCurTime() / 1000;
        }

        let str = DateUtils.dateFormatMD(timer)


        return (
            <Grid container justifyContent='space-between' alignItems='center' direction='row' className={classes.root} >
                <Grid container alignItems='center' style={{ flex: 1, backgroundColor: '#FFF' }}>
                    <Tabs
                        value={value}
                        onChange={(e, val) => this._handleChange(val)}
                        TabIndicatorProps={{ children: <TabIndicator />, style: { backgroundColor: 'transparent', marginBottom: 1.5 } }}
                        style={{ minHeight: 32 }}
                    >
                        <Tab label='直播中' style={{ color: value == 0 ? '#0D0D0D' : '#878787', opacity: 1, fontSize: 13, minHeight: 32 }}></Tab>
                        <Tab label='待开赛' style={{ color: value == 1 ? '#0D0D0D' : '#878787', opacity: 1, fontSize: 13, minHeight: 32 }}></Tab>
                        {/* <Tab label='赛程' style={{ color: value == 2 ? '#0D0D0D' : '#878787', opacity: 1, fontSize: 13, minHeight: 32 }}></Tab> */}
                        <Tab label='赛果' style={{ color: value == 3 ? '#0D0D0D' : '#878787', opacity: 1, fontSize: 13, minHeight: 32 }}></Tab>
                        {/* <Tab label='关注' style={{ color: value == 4 ? '#0D0D0D' : '#878787', opacity: 1, fontSize: 13, minHeight: 32 }}></Tab> */}
                    </Tabs>
                </Grid>

                {/* 日历 */}
                {
                    (value == 1 || value == 2) && <Grid container direction='row' justifyContent='space-between' alignItems='center' style={{ backgroundColor: '#FFF', border: "1px solid #F2F2F2", width: '100%', height: 30 }}>
                        <Typography style={{ fontSize: 11, color: '#0D0D0D', marginLeft: 8 }}>{str}</Typography>
                        <ButtonBase className={classes.button} onClick={() => this.props.onTimer && this.props.onTimer(value)}>
                            <img src={ICON} style={{ width: 15, height: 15, marginRight: 8 }}></img>
                        </ButtonBase>

                    </Grid>
                }


            </Grid>
        );
    }

}

export default withRouter(withStyles((theme) => ({
    root: {
        backgroundColor: '#F0F0F0',
        padding: theme.spacing(0.125, 0, 0, 0),
        boxShadow: '1px 1px 3px #F0F0F0',
    },
    button: {
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(0, 0, 0, 0),
    }
}))(MatchTitle));